export default {
  filterPlaceholder: 'Filtrovať podľa stavu',
  confirmReset: {
    header: 'Resetovať stav súboru "{filePathId}"?',
    message: 'Súbor denníka zostane zachovaný a v ďalšom kole zisťovania sa znova importuje.',
  },
  resetSelected: 'Resetovať vybrané ({count})',
  confirmBulkReset: {
    header: 'Resetovať stav {count} súborov denníka?',
    message: 'Súbory denníka zostanú zachované a v ďalšom kole zisťovania sa znova importujú.',
  },
};
